import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { APPS, APPS_FEATURE } from '../../../../../store/utils/files-names';
import { AppTableModel } from '../../../models/app-table.model';

export const getTableAppsSelector = (state: AppRootState): AppTableModel[] =>
  get(state, `${APPS_FEATURE}.${APPS}`).apps;
